module.exports = __webpack_public_path__ + "05_long_gold.4b688965.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_long_gold.png
// module id = zysV
// module chunks = 0